import { j as c } from "./jsx-runtime-e6RZPHeG.js";
import { memo as m } from "react";
const r = ({
  title: l,
  titleId: e,
  ...o
}) => /* @__PURE__ */ c.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": e,
    ...o,
    children: [
      l ? /* @__PURE__ */ c.jsx("title", { id: e, children: l }) : null,
      /* @__PURE__ */ c.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M223.413 555.725c-17.557 0-31.787-14.251-31.787-31.787v-.213c0-17.685 14.336-32 32-32h257.173c17.685 0 32 14.315 32 32v.213c0 17.536-14.251 31.787-31.787 31.787h-257.6zm-6.741-320h467.371c13.995 0 25.301 14.293 25.301 32 0 17.685-11.307 32-25.301 32H216.672c-14.016 0-25.344-14.315-25.344-32 0-17.707 11.328-32 25.344-32m617.301 160v.213c0 17.557-14.229 31.787-31.787 31.787H223.413c-17.557 0-31.787-14.229-31.787-31.787v-.213c0-17.685 14.336-32 32-32h578.347c17.664 0 32 14.315 32 32m-222.528 338.88h242.901c35.349 0 64-28.651 64-64v-457.28c0-35.349-28.651-64-64-64H170.655c-35.328 0-64 28.651-64 64v457.28c0 35.349 28.672 64 64 64h236.949c2.923 0 4.971 2.859 4.053 5.611l-18.496 55.467a4.24 4.24 0 0 1-4.032 2.923l-60.992.149c-11.755.021-21.269 9.557-21.269 21.333v42.667c0 11.776 9.536 21.333 21.333 21.333h362.667c11.776 0 21.333-9.557 21.333-21.333v-42.624c0-11.797-9.536-21.355-21.333-21.376l-60.928-.149a4.285 4.285 0 0 1-4.053-2.923l-18.496-55.467c-.917-2.752 1.152-5.611 4.053-5.611z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), v = m(r);
export {
  v as default
};
